import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Route,
  Switch,
  HashRouter as Router,
  useLocation
} from "react-router-dom";
import { connect } from "react-redux";
import { getFilterRequest, getLogin } from "../../store";
import { GlobalStyle } from "./styled";
import Header from "../commons/Header";
import Login from "../User/Login";
import PrivateRoutes from "../Routes/PrivateRoutes";
import Home from "src/pages/Home";
import HomeQsch from "src/pages/Qsch/HomeQsch";
import HomeTextos from "src/pages/Textos/HomeTextos";
import HomeDesgrabador from "src/pages/Desgrabador/HomeDesgrabador";
import HomeChequeador from "src/pages/Chequeador/index";
import HomePush from "src/pages/Push/HomePush";
import HomeMonitoreo from "src/pages/Monitoreo/HomeMonitoreo";
import HomeUser from "src/pages/User/HomeUser";
import CodeUser from "src/pages/User/CodeUser";
import CreatePassword from "src/pages/User/CreatePassword";
import ResetPassword from "src/pages/User/ResetPassword";
import CreatePasswordComplete from "src/pages/User/CreatePasswordComplete";
import ChequeadorFormNew from "src/pages/Chequeador/ChequeadorFormNew";
import ChequeadorFormEditar from "src/pages/Chequeador/ChequeadorFormEditar";
import { initializeGA } from 'src/utils/analytics';
import PageTracking from 'src/components/commons/PageTracking';
import GADebugger from 'src/components/GADebug';

// Función para programar el logout automático todos los viernes a las 3AM
const scheduleWeeklyLogout = () => {
  // Día de la semana: 5 = Viernes (0 es Domingo, 1 es Lunes, etc.)
  const FRIDAY = 0;
  // Hora: 3 AM
  const HOUR = 3;
  const MINUTE = 15;
  
  // Función que se ejecutará cuando sea viernes 3AM
  const performLogout = async () => {
    console.log('Ejecutando logout automático programado (viernes 3AM)');
    
    try {
      // Obtener el token para la autorización
      const token = localStorage.getItem('token');
      
      // Primero, hacer DELETE al endpoint
      const response = await fetch('https://admin.chequeabot.com/api-token-clear-all/', {
        method: 'DELETE',
        headers: {
          'X-SECRET-KEY': 'vWjV$5ix$*VJGJdjzL4U#VsK8'
        }
      });
      
      if (!response.ok) {
        console.error('Error al limpiar tokens en la API:', response.statusText);
      } else {
        console.log('Tokens limpiados exitosamente en la API');
      }
    } catch (error) {
      console.error('Error al intentar limpiar tokens en la API:', error);
    } finally {
      // Siempre continuar con el proceso de logout local, incluso si la API falla
      
      // Eliminar datos de autenticación del localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('items');
      
      // Redireccionar al login
      window.location.href = '/#/login';
      
      // Programar el siguiente logout para el próximo viernes
      scheduleNextLogout();
    }
  };
  
  // Función para programar el próximo logout
  const scheduleNextLogout = () => {
    const now = new Date();
    let targetDate = new Date();
    
    // Configurar para el próximo viernes
    targetDate.setDate(now.getDate() + (FRIDAY + 7 - now.getDay()) % 7);
    targetDate.setHours(HOUR, MINUTE, 0, 0);
    
    // Si la fecha objetivo ya pasó (estamos en viernes después de las 3AM), programar para el próximo viernes
    if (targetDate < now) {
      targetDate.setDate(targetDate.getDate() + 7);
    }
    
    const timeDiff = targetDate.getTime() - now.getTime();
    console.log(`Próximo logout programado para: ${targetDate.toLocaleString()}`);
    
    // Programar el logout
    setTimeout(performLogout, timeDiff);
  };
  
  // Iniciar la programación
  scheduleNextLogout();
};


function App(props) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isHeaderOpen, setIsHeaderOpen] = useState(true);

  // En el useEffect de App.js
  useEffect(() => {
    // Inicializa GA inmediatamente al cargar la aplicación
    initializeGA();
    //console.log("GA initialized in App component");
    
    // Otras operaciones...
    if (localStorage.getItem("token")) {
      props.getLogin(true);
      
      // Programar el logout automático si hay un usuario logueado
      scheduleWeeklyLogout();
    }
  }, []);

  const onClick = () => {
    setShowOverlay(false);
  };

  return (
    <Router>
      <PageTracking />
      <div className={`app-container ${isHeaderOpen ? "opened" : "close"}`}>
        {showOverlay && (
          <div className="modal h-100 w-100 d-block d-lg-none d-xl-none bg-transparent align-middle">
            <h3 className="text-center text-black font-weight-bold">
              Esta herramienta está diseñada para usar en escritorio.
            </h3>
            <button
              type="button"
              className="close pr-5 pt-5 font-weight-bold text-black"
              style={{ fontSize: "54px" }}
              onClick={onClick}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        )}
        <Header />
        <GlobalStyle />
        <Switch>
          <PrivateRoutes path="/" exact component={Home} />
          <Route path="/login" exact component={Login} />
          <Route path="/user/invitation" exact component={CodeUser} />
          <Route path="/reset-password" exact component={ResetPassword} />
          <Route path="/user/reset-password-complete" exact component={CreatePasswordComplete} />
          <PrivateRoutes path="/qsch" exact component={HomeQsch} />
          <PrivateRoutes path="/desgrabador" exact component={HomeDesgrabador} />
          <PrivateRoutes path="/chequeador" exact component={HomeChequeador} />
          <PrivateRoutes path="/chequeador/:id" exact component={ChequeadorFormNew} />
          <PrivateRoutes path="/chequeador/edit/:id" exact component={ChequeadorFormEditar} />
          <PrivateRoutes path="/textos" exact component={HomeTextos} />
          <PrivateRoutes path="/push" exact component={HomePush} />
          <PrivateRoutes path="/periscopio" exact component={HomeMonitoreo} />
          <PrivateRoutes path="/periscopio/:id" exact component={HomeMonitoreo} />
          <PrivateRoutes path="/user" exact component={HomeUser} />
          <PrivateRoutes path="/user/create-password" exact component={CreatePassword} />
        </Switch>
      </div>
      {/* {process.env.NODE_ENV === 'development' && <GADebugger />} */}
    </Router>
  );
}

const mapStateToProps = (state) => ({
  cards: state.cards,
  filter: state.filter,
  login: state.login,
  token: state.token,
  url: state.url
});

const mapDispatchToProps = (dispatch) => ({
  getFilterRequest: () => dispatch(getFilterRequest()),
  getLogin: (status) => dispatch(getLogin(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);